<template>
  <div class="hello">
    <div class="slides-container">
      <div class="slide" :style="{
        position: 'absolute',
        top: 0,
        backgroundImage: `linear-gradient(-90deg, #00000000 0%, #0A1F44a5 60%), url(${require('@/assets/b02.webp')})`
      }">
        <div class="t">
          <h1 class="title">Guincho 24 Horas em São Carlos<br><span class="title">Agilidade, Segurança e o Melhor Custo-Benefício!</span></h1>
<p>
Teve um imprevisto? A <strong>Leo Guincho</strong> está pronta para atender você em qualquer ponto de São Carlos, com rapidez, transparência e total profissionalismo. Ligue agora e conte com o nosso suporte imediato!
</p>

          <div class="banner-contato">
            <a target="_blank" href="tel:16991602169" class="btn b2">
              <img class="icon32" width="24" height="24" :src="require('@/assets/phone-32.svg')" alt="whatsapp"> LIGUE AGORA MESMO
            </a>
          </div>
          <div class="banner-contato">
            <a target="_blank"
              href="https://api.whatsapp.com/send?phone=5516991602169&amp;text=Olá%20Leo%20Guincho%20São%20Carlos,%20Gostaria%20de%20solicitar%20um%20orçamento."
              class="btn b1">
              <img class="icon32" width="24" height="24" :src="require('@/assets/whatsapp-32.svg')" alt="whatsapp">
              CHAME NO WHATSAPP
            </a>
          </div>
        </div>
        <div id="circulo-banner" class="banner-container">
            <svg class="rotate" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="300px" height="300px"
              viewBox="0 0 300 300" enable-background="new 0 0 300 300" xml:space="preserve">
              <defs>
                <path id="circulo-rotativo-banner" d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0">
                </path>
              </defs>
              <circle cx="150" cy="100" r="75" fill="none"></circle>
              <g>
                <use xlink:href="#circulo-rotativo-banner" fill="none"></use>
                <text fill="#fff">
                  <textPath xlink:href="#circulo-rotativo-banner" class="rotating-text">
                    Pagamento facilitado no cartão <tspan fill="#00CF4B">•</tspan>
                  </textPath>
                </text>
              </g>
            </svg>
          </div>
      </div>
    </div><br><br>
    <section style="max-width: 90vw; margin: 0 auto!important;">
     <h2 class="title">Precisando de guincho em São Carlos? A Leo Guincho está sempre de prontidão!</h2>
<p>Na <strong>Leo Guincho</strong>, você conta com atendimento rápido, seguro e disponível <strong>24 horas por dia</strong> em toda a região de São Carlos. Seja por pane elétrica, mecânica, pneu furado, falta de combustível ou qualquer imprevisto na estrada, nossa equipe está pronta para prestar o suporte que você precisa com agilidade e total dedicação.</p>

    </section><br><br>
    <section style="max-width: 90vw; margin: 0 auto!important;">
    <div class="title">Conheça alguns
      <h3 class="title">Trabalhos já realizados</h3>
    </div>
    <div style="text-align: left; margin: 20px 0;">
        <div>✅ Guincho leve e pesado</div>
        <div>✅ Reboque para carros, motos e utilitários</div>
        <div>✅ Pane seca (falta de combustível)</div>
        <div>✅ Remoção de veículos em acidentes</div>
        <div>✅ Transporte para oficinas e concessionárias</div>
      </div>
    </section><br>
    <section style="background: #7A7A7A17;">
      <ul data-v-3c4feb3c="" class="g4">
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i01.webp" alt="guincho para carros"
            loading="lazy"></li>
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i02.webp" alt="guincho para carros"
            loading="lazy"></li>
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i03.webp" alt="guincho para carros"
            loading="lazy"></li>
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i04.webp" alt="guincho para carros"
            loading="lazy"></li>
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i05.webp" alt="guincho para vans"
            loading="lazy"></li>
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i06.webp" alt="guincho para vans"
            loading="lazy"></li>
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i07.webp" alt="guincho para vans"
            loading="lazy"></li>
        <li data-v-3c4feb3c=""><img data-v-3c4feb3c="" async="" src="@/assets/i08.webp" alt="guincho para vans"
            loading="lazy"></li>
      </ul>
    </section>
    <section style="max-width: 90vw; margin: 0 auto!important; display: flex; align-items: center;justify-content: center;">
      <a target="_blank" href="tel:16991602169" class="btn b2">
              <img class="icon32" width="24" height="24" :src="require('@/assets/phone-32.svg')" alt="whatsapp"> PEÇA SEU GUINCHO AGORA
            </a>
    </section>
    <section>
      <div>
        <a target="_blank"
          href="https://api.whatsapp.com/send?phone=5516991602169&amp;text=Olá%20Leo%20Guincho%20São%20Carlos,%20Gostaria%20de%20solicitar%20um%20orçamento."
          class="whatsapp-button">
          <img src="@/assets/whatsapp-32.svg" alt="" width="32" height="32">
        </a>
      </div>
      <br><br><br><br>
      <footer class="footer-section">
            <div class="row">
              <div>
                <h3>Sobre Nós</h3>
                <p>A <strong>Leo Guincho</strong> é referência em remoção e transporte de veículos em São Carlos e região. Atuamos com agilidade, segurança e atendimento 24 horas, garantindo suporte nos momentos em que você mais precisa. Com equipe especializada e frota preparada, oferecemos um serviço eficiente e de confiança. Conte com a Leo Guincho sempre que precisar!</p>

              </div>
              <div>
                <h3>Informações Do Negócio</h3>
                <div class="contact-info">
                  <a target="_blank"
                    href="https://api.whatsapp.com/send?phone=5516991602169&amp;text=Olá%20Leo%20Guincho%20São%20Carlos,%20Gostaria%20de%20solicitar%20um%20orçamento."
                    class="icon-text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-whatsapp" viewBox="0 0 16 16">
                      <path
                        d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>&nbsp;
                    <span>(16) 9 9160-2169</span>
                  </a>
                  <a target="_blank" href="tel:16991602169" class="icon-text"><svg xmlns="http://www.w3.org/2000/svg"
                      width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                      <path
                        d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                    </svg>&nbsp;<span>(16) 9
9160-2169</span></a>
                  <a target="_blank" href="mailto:contato@leoguinchosaocarlos.com.br" class="icon-text"><svg
                      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-envelope" viewBox="0 0 16 16">
                      <path
                        d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                    </svg>&nbsp;<span>contato@leoguinchosaocarlos.com.br</span></a>
                </div>
              </div>
              <div>
                <h3>ACEITAMOS CARTÕES</h3>
                <div style="min-width:100%; display: flex; align-items: center; justify-content: center; flex-direction: column;">
                  <img style="max-width: 90%!important;" src="@/assets/cartoes.webp" width="300" />
                  <img style="max-width: 90%!important;" src="@/assets/ssl.webp" width="300" />
                </div>
                <div></div>
              </div>
            </div>
          <div class="copyright-area">
            <div>
              <p style="text-align: center">&copy; {{ year }} - Todos os direitos reservados</p>
            </div>

          </div>
      </footer>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;700&display=swap');

.banner-container {
  overflow: hidden;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height:150px;
  max-width: 150px;
  top: 0;
  right:0px;
  @media only screen and (max-width: 600px) {
    top: 40px;
  }
}

.rotate {
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#circulo-banner::before {
    content: '';
    background-image: url("@/assets/rotacao-cartao.webp");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
}
text {
  font-size: 19px;
  font-weight: bold;
  text-transform: uppercase;
}

* {
  overflow: hidden;
  text-decoration: none;
}
/* .btn {
    background: #0A1F44;
    color: #fff!important;
    padding: 20px 30px !important;
    border-radius: 99px;
    max-width: 20vw !important;
    min-width: 20vw !important;
    margin: 50px;
    animation: pulse 4s infinite, pisca 5s infinite;
    box-shadow: 0 0 21px -6px #0A1F4471;
} */
@keyframes pulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05,1.05,1.05)
    }

    to {
        transform: scaleX(1)
    }
}
@keyframes pisca {
    70% {
        box-shadow: 0 0 0 25px transparent
    }

    to {
        box-shadow: 0 0 0 0 transparent
    }
}
.slides-container {
  border-top: 15px solid #0A1F44;
  position: relative;
  max-width: 100vw;
  min-width: 100vw;
  left: 0!important;
  height: 600px;
  overflow: hidden
}
body{
  background: #0A1F44;
}
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.slide[style*="display: block;"] {
  opacity: 1;
}

.g4 {
    padding: 0 !important;
    margin: 0 auto !important;
    display: grid;
    max-width: 90% !important;
    @media only screen and (max-width: 600px) {
        max-width:100%!important;
        grid-template-columns: repeat(2,50%)
    }
    grid-template-columns: repeat(4, 25%);
    -moz-column-gap: 5px;
    column-gap: 5px;
    row-gap: 2.5px;
  img {
    max-width: 100% !important;
    min-width: 100% !important;
    width: auto;
    height: auto;
  }
}

.t {
  position: absolute;
  top: 5%;
  left: 6%;
  z-index: 10;
  max-width: 50vw !important;
  min-height: 100% !important;

  * {
    color: #fff !important;
  }
  .title{
    @media only screen and (max-width: 600px) {
      font-size: 48px;
    }
  }
  @media only screen and (max-width: 600px) {
    left: 5%;
    max-width: 90vw !important;
    min-height: 100% !important;
  }
}

.font-hover {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 2.5rem;
  text-transform: uppercase;
}

.banner-contato {
  display: flex;
  flex-direction: column;
  /* Ajuste conforme necessário */
  gap: 16px;

  /* Espaçamento entre os alvos de toque */
  * {
    color: #fff !important
  }
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  margin:20px auto;
  border: none;
  border-radius: 36px;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
  max-width: 25vw !important;

  @media only screen and (max-width: 600px) {
    max-width: 60vw !important;
    min-width: 60vw !important;
    font-size: 0.7rem;
  }

  cursor: pointer;
}

.b1 {
  background: #00CF4B;
  color: white;
  animation: pisca 1.5s infinite;
  box-shadow: 0px 0px 21px -6px #00CF4B;
}

.b2 {
  background-color: darken(#0A1F44, 10%);
  box-shadow: 0px 0px 21px -6px #0A1F44;
  animation: pisca 1.5s infinite;
  color: white;
}

.icon32 {
  margin-right: 8px;
}

.btn:hover {
  background-color: #000
}

.btn.b2:hover {
  background-color: #000
}
.servicos{
    display: flex;
    flex-wrap: wrap;
    li {
    min-width: 45%;
    @media only screen and (max-width: 600px) {
        min-width: 100%;
    }
}
}
.footer-content{
    padding: 0 5px;
    p{
      text-align: left!important;
    }
}
.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 18px;
    margin-right: 5px;
    color: #d5d5d5;
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f6;
    vertical-align: middle;
    border-radius: 50%;
}
.row {
    display: flex;
    position: relative;
    width: 92vw;
    margin: 0 auto!important;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px;
    div{
      &:left{
        padding:5px 0;
        background: #00CF4B;
      }
       img{
       min-width: 80%!important;
       }
        width: calc((90vw/3) - 4px);
        @media only screen and (max-width: 600px) {
            width: 95%;
    }
    }
}
*{
    overflow: hidden!important;
}
h3 {
    @media only screen and (max-width: 600px) {
            font-size: 28px;
    }
    font-family: "Teko", Sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    color:#000
}
.footer-section {
    min-width: 100vw!important;
    max-width: 100vw!important;
    background: #7A7A7A17;
    color: #000
}

.contact-info{
    min-width: 55%;
    margin: 0 auto!important;
    .icon-text {
    display: flex;
    margin-bottom: 10px;
    color:#000!important;
}
}

.copyright-area {
    padding: 15px 0;
    color: #000;
    text-align: center;
    div{
        margin: 0 auto!important;
    }
}
.copyright{
    display: flex;
    justify-content: center;
}
@media (max-width: 767px) {
    .footer-menu {
        margin-top: 30px;
    }
}
.whatsapp-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #00CF4B;
        width: 48px;
        height: 48px;
        padding: 20px;
        font-size: 16px;
        border-radius: 100%;
        text-decoration: none;
        animation: pulse 4s infinite, pisca 1.5s infinite;
        box-shadow: 0px 0px 21px -6px #25D366;
        // animation: pisca 1.5s infinite;
        transition: background-color 0.3s ease;
        position: fixed;
        bottom: 2vh;
        right: 5vw;
        @media only screen and (max-width: 600px) {
        }
        z-index: 1000;
    }

    .whatsapp-button:hover {
        background-color: #2aee72;
    }
</style>
